import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const MaintenanceOrderState = Immutable.fromJS({
	order: {
		orderId: '',
		sOrderDate: '',
		caseNumber: '',
		caseName: '',
		caseOfficer: '',
		sales: '',
		sDueDate: '',
		note: '',
		noteDisplay: '',
		customerId: '',
		customerName: '',
		phone: '',
		fax: '',
		address: ''
	},
	orderValidation: {
		orderId: {
			validationState: null,
			helpBlock: null
		},
		sOrderDate: {
			validationState: null,
			helpBlock: null
		},
		customerId: {
			validationState: null,
			helpBlock: null
		},
		caseNumber: {
			validationState: null,
			helpBlock: null
		},
		caseName: {
			validationState: null,
			helpBlock: null
		},
		caseOfficer: {
			validationState: null,
			helpBlock: null
		},
		sales: {
			validationState: null,
			helpBlock: null
		},
		sDueDate: {
			validationState: null,
			helpBlock: null
		},
		note: {
			validationState: null,
			helpBlock: null
		},
		noteDisplay: {
			validationState: null,
			helpBlock: null
		}
	},
	orderDetail: {
		category:'消防衣',
		checkSet: null,
		catId: 0,
		setId: null,
		orderId: '',
		sQuantity: '',
		sPrice:'',
		details:[],
	},
	orderDetailValidation: {
		sQuantity: {
			validationState: null,
			helpBlock: null
		}
	},
	alertStyle: null,
	alertMessage: null,
	showAddOrderModal: false,
	showEditOrderModal: false,
	showEditOrderDetailModal: false,
	showViewOrderModal: false,
	forInsert: true,
	step1Class: 'active',
	step2Class: 'default',
	step1Display: '',
	step2Display: 'none',
	specIds: [],
	showSpecIdHasLabel: 'none',
	showSpecIdNoLabel: '',
	allCustomerIds: [],
});

const maintenanceOrderReducer = handleActions({

	CHANGE_MAINTENANCE_ORDER_VALUE: (state, { payload }) => {
		let order = state.get('order');
		return state.merge({
			order: order.set(payload.id, payload.value),
		})
	},

	SET_DETAIL_CAT: (state, { payload }) => {
		let orderDetail = state.get('orderDetail');
		orderDetail = orderDetail.set('category', payload.category);
		orderDetail = orderDetail.set('catId', payload.index);
		return state.merge({
			orderDetail: orderDetail,
		})

	},

	RESET_DETAIL_CHECK_SET: (state, { payload }) => {
		let orderDetail = state.get('orderDetail');
		orderDetail = orderDetail.set('sQuantity', '');
		orderDetail = orderDetail.set('sPrice', '');
		orderDetail = orderDetail.set('checkSet', '');
		return state.merge({
			orderDetail: orderDetail,
		})
	},

	SET_DETAIL_CHECK_SET: (state, { payload }) => {
		let orderDetail = state.get('orderDetail');
		orderDetail = orderDetail.set('checkSet', payload.category);
		orderDetail = orderDetail.set('setId', payload.index);
		return state.merge({
			orderDetail: orderDetail,
		})
	},
	
	SET_M_ORDER_DETAILS: (state, { payload }) => {
		let orderDetail = state.get('orderDetail');
		orderDetail = orderDetail.set('details', payload.data);
		return state.merge({
			orderDetail: orderDetail,
		})
	},

	ADD_MAINTENANCE_ORDER: (state, { payload }) => {
		if (payload.statusCode === '0') {
			let order = state.get('order');
			let orderDetail = state.get('orderDetail');
			return state.merge({
				alertStyle: payload.data.alertStyle,
				alertMessage: payload.data.alertMessage,
				step1Class: 'default',
				step2Class: 'active',
				step1Display: 'none',
				step2Display: '',
				orderDetail: orderDetail.set('orderId', order.get('orderId')),
			})
		} else {
			return state.merge({
				order: payload.data.bean,
				orderValidation: payload.data.valBean,
				alertStyle: payload.data.alertStyle,
				alertMessage: payload.data.alertMessage,
			})
		}
	},
	EDIT_MAINTENANCE_ORDER: (state, { payload }) => {
		return state.merge({
			order: payload.data.bean,
			orderValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_MAINTENANCE_ORDER: (state, { payload }) => {
		return state.merge({
			order: payload.data
		})
	},
	ADD_MAINTENANCE_ORDER_DETAIL: (state, { payload }) => {

		return state.merge({
			orderDetailValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	CHANGE_MAINTENANCE_ORDER_DETAIL_VALUE: (state, { payload }) => {

		let orderDetail = state.get('orderDetail');
		return state.merge({
			orderDetail: orderDetail.set(payload.id, payload.value),
		})
	},

	FIND_MAINTENANCE_ORDER_DETAIL: (state, { payload }) => {
		return state.merge({
			orderDetail: payload.data
		})
	},

	OPEN_ADD_MAINTENANCE_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showAddOrderModal: true
		})
	},
	OPEN_EDIT_MAINTENANCE_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			forInsert: payload.forInsert,
			showEditOrderModal: true
		})
	},
	OPEN_EDIT_Maintenance_ORDER_DETAIL_MODAL: (state, { payload }) => {
		let orderDetail = state.get('orderDetail');
		return state.merge({
			showEditOrderDetailModal: true,
			orderDetail: orderDetail.set('orderId', payload.orderId),
		})
	},
	OPEN_VIEW_MAINTENANCE_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			showViewOrderModal: true
		})
	},
	CLOSE_MAINTENANCE_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			order: {
				orderId: '',
				sOrderDate: '',
				customerId: '',
				caseNumber: '',
				caseName: '',
				caseOfficer: '',
				sales: '',
				sDueDate: '',
				note: '',
				customerName: '',
				phone: '',
				fax: '',
				address: ''
			},
			orderValidation: {
				orderId: {
					validationState: null,
					helpBlock: null
				},
				sOrderDate: {
					validationState: null,
					helpBlock: null
				},
				customerId: {
					validationState: null,
					helpBlock: null
				},
				caseNumber: {
					validationState: null,
					helpBlock: null
				},
				caseName: {
					validationState: null,
					helpBlock: null
				},
				caseOfficer: {
					validationState: null,
					helpBlock: null
				},
				sales: {
					validationState: null,
					helpBlock: null
				},
				sDueDate: {
					validationState: null,
					helpBlock: null
				},
				note: {
					validationState: null,
					helpBlock: null
				}
			},
			orderDetail: {
				category:'消防衣',
				checkSet: null,
				catId: 0,
				setId: 0,
				orderId: '',
				sQuantity: '',
				details:[],
			},
			orderDetailValidation: {
				sOrderDetailId: {
					validationState: null,
					helpBlock: null
				},
				gearName: {
					validationState: null,
					helpBlock: null
				},
				customerGearName: {
					validationState: null,
					helpBlock: null
				},
				modelName: {
					validationState: null,
					helpBlock: null
				},
				specIdHasLabel: {
					validationState: null,
					helpBlock: null
				},
				specIdNoLabel: {
					validationState: null,
					helpBlock: null
				},
				sQuantity: {
					validationState: null,
					helpBlock: null
				}
			},
			alertStyle: null,
			alertMessage: null,
			showAddOrderModal: false,
			showEditOrderModal: false,
			showEditOrderDetailModal: false,
			showViewOrderModal: false,
			forInsert: true,
			step1Class: 'active',
			step2Class: 'default',
			step1Display: '',
			step2Display: 'none',
		})
	}
}, MaintenanceOrderState);

export default maintenanceOrderReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceOrderReducer.js